<template>
  <div class="container-fluid mx-3 my-5">
    <div class="row">
      <div class="col-12 d-flex align-items-center justify-content-start mb-5">
        <h1>Agency Contract</h1>
      </div>
    </div>
    <div class="row">
      <div
        class="col-12 d-flex align-items-center justify-content-center flex-column"
      >
        <div style="position: relative">
          <!-- show the pdf  -->
          <img
            :src="snapshots[currentPage].url"
            style="width: 850px"
            class="img-responsive"
            v-if="snapshots[currentPage]"
            :key="currentPage"
          />
          <div
            class="p-3 d-flex align-items-center justify-content-center sign-box"
            :class="{
              'agency-box': !signature.user.is_ottley_signatory,
              'ottley-box': signature.user.is_ottley_signatory,
            }"
            @click="openBox"
            v-if="!signature.is_signed && currentPage == 0"
          >
            <p class="mb-0 text-white text-center">
              Please sign here
              <br />
              <strong>
                {{ signature.user.first_name }} {{ signature.user.last_name }}
              </strong>
            </p>
          </div>
          <!-- end show pdf -->
        </div>
        <div class="d-flex align-items-center justify-content-end mt-3">
          <el-button
            type="success"
            @click="downloadPdf"
            class="mr-2"
            size="small"
            v-if="latestPdf"
          >
            <i class="fas fa-download mr-2"> </i>
            Download PDF
          </el-button>
          <el-button
            type="primary"
            @click="prevPage"
            class="mr-2"
            size="small"
            :disabled="!(currentPage >= 1)"
          >
            Previous Page
          </el-button>
          <el-button
            type="primary"
            @click="nextPage"
            size="small"
            :disabled="!(currentPage < snapshots.length - 1)"
          >
            Next Page
          </el-button>
        </div>
      </div>
    </div>
    <signature-modal
      :save-url="savePath"
      :open.sync="open"
      :contract="contract"
    >
    </signature-modal>
  </div>
</template>

<script>
import SignatureModal from "./components/SignatureModal.vue";
export default {
  props: {
    savePath: {
      required: true,
      type: String,
    },
    initial_contract: {
      required: true,
      type: Object,
    },
    signature: {
      required: true,
      type: Object,
    },
  },
  components: {
    SignatureModal,
  },
  data() {
    return {
      contract: this.initial_contract,
      open: false,
      currentPage: 0,
    };
  },
  methods: {
    downloadPdf() {
      window.open(this.latestPdf.url, "_blank");
    },
    nextPage() {
      if (this.currentPage >= this.snapshots.length - 1) {
        return;
      }
      this.currentPage += 1;
    },
    prevPage() {
      if (this.currentPage <= 0) {
        return;
      }
      this.currentPage -= 1;
    },
    openBox() {
      if (this.signature.is_signed) {
        return;
      }
      this.open = true;
    },
  },
  computed: {
    latestPdf() {
      const medias = this.contract.media.filter(
        (media) => media.collection_name == "contract_pdf"
      );

      return medias[0] || null;
    },
    snapshots() {
      return this.contract.snapshots;
    },
  },
};
</script>

<style lang="scss" scoped>
.sign-box {
  cursor: pointer;
  position: absolute;
  background: #3498db;
  opacity: 1;
  width: 180px;
  height: 50px;
  color: #fff;
  &.agency-box {
    left: 0px;
    bottom: 0px;
  }
  &.ottley-box {
    right: 0px;
    bottom: 0px;
  }
}
</style>
